import { flatten } from 'flat';
import { get } from 'lodash';

import { StepValidationStatuses } from 'enums';

export const getStepValidationStatus = (formik: any) => {
  const flattenErrors: any = flatten(formik.errors);
  const hasVisibleErrors = Object.keys(flattenErrors).some((key) =>
    get(formik.touched, key, false),
  );

  if (hasVisibleErrors) return StepValidationStatuses.Error;

  if (formik.isValid) return StepValidationStatuses.Finish;

  return StepValidationStatuses.Wait;
};
